import * as React from 'react';
import { cn } from './lib/utils';

const ALERT_VALUE = {
  none:     'text-text-dark',
  warning:  'text-yellow-nn',
  critical: 'text-red-critical',
};

const DENSITY_CONFIG = {
  compact:  { padding: 'p-1.5', gap: 'gap-0' },
  default:  { padding: 'p-2',   gap: 'gap-0.5' },
  spacious: { padding: 'p-3',   gap: 'gap-1' },
};

/**
 * Small metric tile used in DomainInsightsPanel expanded content.
 *
 * alertLevel="none"     — default text color (default)
 * alertLevel="warning"  — value in yellow
 * alertLevel="critical" — value in red
 *
 * density="compact" | "default" | "spacious"
 *   Controls padding and gap between label and value together.
 *
 * Backward compat: alert={true} → alertLevel="critical"
 */
function MetricMini({ label, value, alert = false, alertLevel, density = 'default', className }) {
  const level = alertLevel ?? (alert ? 'critical' : 'none');
  const dc = DENSITY_CONFIG[density] ?? DENSITY_CONFIG.default;

  return (
    <div className={cn('flex flex-col rounded bg-surface', dc.padding, dc.gap, className)}>
      <span className="text-caption text-text-muted leading-tight">{label}</span>
      <span className={cn('text-heading-sm font-bold leading-tight', ALERT_VALUE[level] ?? ALERT_VALUE.none)}>
        {value}
      </span>
    </div>
  );
}

export { MetricMini };
